import React, { useEffect, useState } from 'react';
import { getForms } from '../../../actions/formActions';
import { getAccessControl, saveAccessControl } from '../../../actions/adminActions';
import { useSelector, useDispatch } from 'react-redux';
import SearchBox from '../../Common/SearchBox/SearchBox';
import _ from 'lodash'
import { toast } from 'react-toastify';

const AccessControl = () => {
    const searchBoxKey = "access_control_search_form";
    const submitForm = "access_control_submit_form";
    const dispatch = useDispatch();
    const adminState = useSelector((state) => state.admin);
    const formState = useSelector((state) => state.forms);
    const { formJson = {} } = formState;
    const searchBoxJson = formJson[searchBoxKey] || {};
    const submitBoxJson = formJson[submitForm] || {};
    const { accessControlList = {}, saveResponse = {} } = adminState;
    const [fetchingList, setFetchingList] = useState(false);
    const [fetchingSearchForm, setFetchingSearchForm] = useState(_.isEmpty(searchBoxJson));
    const [fetchingSubmitForm, setFetchingSubmitForm] = useState(_.isEmpty(submitBoxJson));
    const [searchPayload, setSearchPayload] = useState({});
    const [accessControlPayload, setAccessControlPayload] = useState(accessControlList);

    useEffect(() => {
        dispatch(getForms(searchBoxKey, submitForm));
    }, [])

    useEffect(() => {
        if (!_.isEmpty(saveResponse) && fetchingList) {
            setFetchingList(false);
            const { status = {} } = saveResponse;
            const { success = false } = status;
            if (success) {
                toast.success('Successfully Updated');
            }
        }
    }, [saveResponse])

    useEffect(() => {
        if (!_.isEmpty(accessControlList) && fetchingList) {
            setFetchingList(false);
            setAccessControlPayload({ accessControlList });
        }
    }, [accessControlList])

    useEffect(() => {
        if (!_.isEmpty(searchBoxJson) && fetchingSearchForm) {
            setFetchingSearchForm(false);
        }
    }, [searchBoxJson])

    useEffect(() => {
        if (!_.isEmpty(submitBoxJson) && fetchingSubmitForm) {
            setFetchingSubmitForm(false);
        }
    }, [submitBoxJson])

    const handleSearch = (payload) => {
        setFetchingList(true);
        setSearchPayload(payload);
        dispatch(getAccessControl(payload));
    }

    const handleSubmit = (payload) => {
        setAccessControlPayload(payload);
        setFetchingList(true);
        const { accessControlList = {} } = payload;
        dispatch(saveAccessControl({ ...searchPayload, ...accessControlList }));
    }

    return (
        <div style={{ position: 'relative', paddingBottom: '0px' }}> {/* Added padding-bottom */}
            <SearchBox
                searchBoxJson={searchBoxJson}
                onSearch={handleSearch}
                fetchingForm={fetchingSearchForm}
                updatedValues={{}}
                fetchingList={fetchingList}
            />

            {!_.isEmpty(accessControlPayload) ? <SearchBox
                searchBoxJson={submitBoxJson}
                onSearch={handleSubmit}
                fetchingForm={fetchingSubmitForm}
                updatedValues={accessControlPayload}
                fetchingList={fetchingList}
            /> : ''}
        </div>
    );
};

export default AccessControl;